<template>
  <div class="popup-menu" v-click-outside="() => $emit('close')">
    <slot></slot>
  </div>
</template>

<script>
import vClickOutside from 'v-click-outside'
export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },
  name: 'PopupMiniMenu',
}
</script>

<style lang="scss" scoped>
.popup-menu {
  background-color: white;
  position: absolute;
  z-index: 1;
  border: 1px solid $flax-bloom;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  text-align: left;
}
</style>
